// extracted by mini-css-extract-plugin
export default {"fullWidth":"so-z","image":"to-z","lazyLoadPicture":"uo-z","lazyLoadSpinner":"vo-z","lazyLoadSpin":"wo-z","lazyLoadImage":"xo-z","hasStyledAspectRatio":"yo-z"};